<template>
    <b-container 
        class="bv-example-row" 
        style="margin-bottom: 64px; min-height: 50vh"
    >
        <b-row class="mt-4">
            <b-col>
                <h3>
                    {{ `Device` }} <br/>
                    <small style="font-size:70%"> {{`IMEI: ${imei}`}} </small>
                </h3>
            </b-col>
        </b-row>

        <b-row class="mt-4 mb-3" style="text-align: left">
            <b-col style="padding-right: 0px; padding-left: 60px;">
                <h5 
                    class="mb-4" 
                    :style="`text-align:center; ${instructions_margin}`"
                > <strong>{{ subtitle }}</strong> </h5>

                <b-form-group>
                    <b-form-checkbox-group
                        id="installation-instructions"
                        v-model="selected"
                        :options="options"

                        :style="$mq === 'lg' ? 'width:60%; margin: auto' : checkbox_margin"
                        stacked
                    />
                </b-form-group>
                <h5
                        class="mb-4"
                        :style="`text-align:center; ${instructions_margin}`"
                > <strong>Click <a href="https://irp.cdn-website.com/835bf33d/files/uploaded/MeterDog%20Solo%20Quick%20Guide%2092421.pdf">HERE</a> for device & installation information.</strong> </h5>
            </b-col>
        </b-row>

        <b-row class="mb-2" style="text-align:center">
            <b-col >
                 <b-button 
                    block 
                    variant="success"
                    style="width:60%; margin:auto; height: 48px"
                    :disabled="selected.length !== options.length"
                    @click="next"
                > Continue </b-button>
                <br/>
                <b-button block
                     class="mb-5"
                     variant="light"
                     style="width:60%; margin:auto; height: 48px; padding-top: 11px"
                     @click="cancelSelfInstall()"><strong>Cancel Installation</strong></b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

    const options = [
        'Install the Sensor',
        'Mount the antennae in a good location',
        'Activate or Power up your Device'
    ]

    export default {
        name: 'InstallInstructions',

        props:{
            imei: { type: String }
        },        


        data(){
            return {
                subtitle: 'Check Each Box to proceed',
                selected: [],
                options: options.map((option, i) => ({ text: option, value: i})),
                instructions_margin: 'margin-left: -30px; margin-right: 30px;' ,
                checkbox_margin:  'margin-left: 200px; margin-right: 10px;'
            }
        },

        methods:{
            next(){ 
                this.$router.push(`/installation/create/${this.imei}`)
            },
            cancelSelfInstall(){
                localStorage.clear()
                window.location.replace("http://konametrix.com")
            },
        },
    }

</script>

<style>

    .custom-checkbox{ margin-bottom: 25px }
    .custom-control-input:checked ~ .custom-control-label::before {
        color: #fff;
        border-color: black;
        background-color: black;
    }

    .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
        color: #fff;
        background-color: #999999;
        border-color: #999999;
    }

</style>
